module.exports = __webpack_public_path__ + "img/Comic04-2.56f200ef.png";